import React from "react";
import { API_ROOT, API_ROOT1 } from "../utils/api-config";
import { Link, withRouter } from "react-router-dom";
import { connect } from "react-redux";
import ax from "../auth/axios";
import { deleteCurrentUser } from "../../actions/authAction";
import Nav from "react-bootstrap/Nav";
import Dropdown from "react-bootstrap/Dropdown";
import Button from "react-bootstrap/Button";

class NavbarShow extends React.Component {
  constructor(props) {
    super(props);
  }

  // const { setCurrentUser } = props;
  // const { isLoggedIn } = props.user;
  handleClick = () => {
    ax.delete(`${API_ROOT}/logout/`)
      .then((response) => {
        this.handleLogout();
        this.redirect();
      })
      .catch((error) => console.log(error));
  };
  redirect = () => {
    this.props.history.push({ pathname: "/" });
  };
  handleLogout = () => {
    // console.log(this.props);
    this.props.deleteCurrentUser({
      currentUser: null,
      isLoggedIn: false,
      loading: false,
    });
    localStorage.removeItem("persist:root");
  };
  render() {
    const { isLoggedIn, loading, currentUser } = this.props.user;
    // const HOST = window.location.host;
    return (
      <Nav
        style={{ zIndex: 1 }}
        className="justify-content-space-around mb-2 position-absolute"
      >
        {isLoggedIn ? (
          <Dropdown as={Nav.Item}>
            <Dropdown.Toggle variant="success">React Menu</Dropdown.Toggle>
            <Dropdown.Menu>
              <Dropdown.Item
                as={"a"}
                href={`${API_ROOT1}/deliveries`}
                className="text-info"
              >
                Home
              </Dropdown.Item>
              <Dropdown.Item as={Link} to="/trackers" className="text-info">
                Shopify Orders
              </Dropdown.Item>
              <Dropdown.Item as={Link} to="/logistics/deliveries" className="text-info">
                Logistics
              </Dropdown.Item>
              <Dropdown.Item as={Link} to="/inquiries" className="text-info">
                Inquiries
              </Dropdown.Item>
              <Dropdown.Item as={Link} to="/feedback" className="text-info">
                Feedback
              </Dropdown.Item>
              <Dropdown.Item as={Link} to="/messages" className="text-info">
                Messages
              </Dropdown.Item>
              <Dropdown.Item as={Link} to="/clicks" className="text-info">
                Clicks
              </Dropdown.Item>
              <Dropdown.Divider />
              <Dropdown.Item
                as={Link}
                to={`/users/${currentUser.currentUser.id}`}
                className="text-success"
              >
                {currentUser.currentUser.first_name}'s Profile{" "}
              </Dropdown.Item>
              <Dropdown.Item
                as={Link}
                to="/logout"
                onClick={this.handleClick}
                className="text-success"
              >
                Log Out
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        ) : (
          <Nav.Item>
            <Link to="/login">
              <Button variant="outline-danger">Log In </Button>
            </Link>
          </Nav.Item>
        )}
      </Nav>
    );
  }
}
const mapStateToProps = ({ user }) => ({
  user: user,
});
const mapDispatchToProps = (dispatch) => ({
  deleteCurrentUser: () => dispatch(deleteCurrentUser()),
});

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(NavbarShow)
);
